export const foodAndBeverageData = {
  themeColor: "#2A8636",
  heroStyles: {
    removeOverlay: true,
    titleColor: "#000000",
    bodyColor: "#58585B"
  },

  breadcrumbs: [
    {
      text: "HOME",
      url: "/"
    },
    {
      text: "FOR PROS",
      url: null
    },
    {
      text: "INDUSTRIAL SOLUTIONS",
      url: "/industrial"
    },
    {
      text: "FOOD & BEVERAGE",
      url: null
    }
  ],

  heroCTAs: {
    topButton: {
      text: "REQUEST SAMPLES",
      url: "/industrial/samplesrequest/"
    },
    mainButtons: [
      {
        text: "ASK A TECHNICAL SPECIALIST",
        url: "/industrial/technicalspecialist/",
        variant: "outline"
      },
      {
        text: "REQUEST A SITE ASSESSMENT",
        url: "#site-assessment-form",
        variant: "red"
      }
    ]
  },

  components: [ 
    {
      component: "cardDeck",
      variant: "vertical",
      id: "product-lines",
      eyebrow: "Backed by WD-40® brand. ",
      title: "BUILT FOR FOOD-GRADE DEMANDS.",
      body: "Meet the newest additions to the WD-40 Specialist® line: the Food-Processing Facility Contact Cleaner, EZ-Pods Degreaser & Cleaner, and Food-Grade Lubricant & Penetrant. Each formula is NSF registered and engineered to take on tough maintenance challenges in food-processing environments—all without compromising safety.",
      cards: [
        {  
          id: "clean-degrease",
          image: "/img/industrial-page/new/food-and-beverage/Food & Bev - Cleaner Degreaser Image 1.png",
          title: "CLEANERS & DEGREASERS",
          description: "Remove grease, grime, and contaminants fast",
          linkUrl: "/products/?functionality=clean-degrease"
        },
        {
          id: "lube-penetrants",
          image: "/img/industrial-page/new/food-and-beverage/Food & Bev - Lubricant & Penetrant Image 1.png",
          title: "LUBRICANTS & PENETRANTS",
          description: "Free stuck parts and reduce friction",
          linkUrl: "/products/?functionality=lubricates%2Cpenetrate-loosen"
        }
      ],
      ctaText: "BROWSE ALL INDUSTRIAL PRODUCTS",
      ctaUrl: "/products/"
    },
    
    {
      component: "cardDeck",
      variant: "icons",
      id: "facility-applications",
      title: "FACILITY APPLICATIONS",
      cards: [
        {
          id: "conveyor-systems",
          image: "/img/industrial-page/new/Conveyor Systems Icon.png",
          title: "CONVEYOR SYSTEMS",
          subtitle: "Keep food-safe lines moving.",
          description: '<a href="/products/wd-40-specialist-food-grade-lubricant-and-penetrant/" target="_blank" rel="noopener noreferrer">WD-40 Specialist Food-Grade Lubricant & Penetrant</a> reduces friction, displaces moisture, and meets NSF H1 standards—protecting equipment and production integrity.'
        },
        {
          id: "electrical-systems",
          image: "/img/industrial-page/new/Electrical Systems Icon.png",
          title: "ELECTRICAL SYSTEMS",
          subtitle: "Protect food-safe electrical components.",
          description: '<a href="/products/wd-40-specialist-food-processing-electric-contact-cleaner/" target="_blank" rel="noopener noreferrer">WD-40 Specialist Food-Processing Facility Electric Contact Cleaner</a> safely removes contaminants and dries quickly without residue—ideal for cleaning sensitive electronics in food processing environments where cleanliness and performance matter.'
        },
        {
          id: "general-maintenance",
          image: "/img/industrial-page/new/General Maintence Icon.png",
          title: "GENERAL MAINTENANCE",
          subtitle: "Built for food-safe performance.",
          description: '<a href="/products/wd-40-specialist-food-processing-degreaser-cleaner-ez-pods/" target="_blank" rel="noopener noreferrer">WD-40 Specialist Food-Grade & Food-Processing Facility solutions—Lubricant & Penetrant</a>, <a href="/products/wd-40-specialist-food-processing-electric-contact-cleaner/" target="_blank" rel="noopener noreferrer">Electric Contact Cleaner</a>, <a href="/degreaser-and-cleaner-ez-pods/" target="_blank" rel="noopener noreferrer">Degreaser & Cleaner EZ-Pods</a> help reduce downtime and keep food production running clean and compliant.'
        }
      ]
    },

    {
      component: "fullWidthCTA",
      id: "facility-map",
      title: "TRUSTED SOLUTIONS FOR FOOD-GRADE AND FOOD-PROCESSING FACILITY PERFORMANCE ",
      buttons: [
        {
          text: "DOWNLOAD PRODUCT GUIDE",
          url: "https://files.wd40.com/pdf/25-WD40-00235-Food-Grade-Mini-Brochure-C7-REV-Preview.pdf?utm_source=qrcode&utm_medium=print&utm_campaign=qrcode_foodgradeflipbook",
          isSecondary: false
        }
      ]
    },


    {
      component: "cardDeck",
      variant: "badges",
      id: "badges-card-deck",
      title: "Introducing<br>the WD-40 Brand<br>Job Done Right® System",
      subtitle: "Experience a comprehensive solution designed to protect your equipment at every stage.",
      body: "This end-to-end approach ensures optimal performance, reduces the risk of failures, and keeps your machinery running smoothly.",
      extraImages: [
        "/img/industrial-page/new/WD40 - PCLP Graphic_v3 1.png",
        "/img/industrial-page/new/WD-40 Specialist Line 2.png"
      ],
      cards: [
        {
          id: "prep-it",
          image: "/img/industrial-page/new/Industrial Solutions - Prep It - Image.png",
          title: "Prep It",
          description: "Start every job with thorough preparation"
        },
        {
          id: "clean-it",
          image: "/img/industrial-page/new/Industrial Solutions - Clean It - Image.png",
          title: "Clean It",
          description: "Clean your surface for optimal lubrication"
        },
        {
          id: "lube-it",
          image: "/img/industrial-page/new/Industrial Solutions - Lube It - Image.png",
          title: "Lube It",
          description: "Experience superior performance with the best lubrication products on the market"
        },
        {
          id: "protect-it",
          image: "/img/industrial-page/new/Industrial Solutions - Protect It - Image.png",
          title: "Protect It",
          description: "Safeguard your hard work with the trusted protection of the WD-40 Brand"
        }
      ]
    },

    {
      component: "cardDeck",
      variant: "products"
    },

    {
      component: "fullWidthCTA",
      id: "safety-efficiency",
      title: "SOLUTIONS TO MAXIMIZE SAFETY & EFFICIENCY",
      buttons: [
        {
          text: "SAFETY DATA SHEETS",
          url: "https://wd40company.com/partners-suppliers/safety-data-sheets/?region=USA",
          isSecondary: true
        },
        {
          text: "REQUEST SAMPLES",
          url: "/industrial/samplesrequest/",
          isSecondary: false
        }
      ]
    },
    {
      component: "NumberedStepsList",
      id: "trial-program",
      eyebrow: "PREP IT. CLEAN IT. LUBE IT. PROTECT IT.",
      title: "WD-40 BRAND JOB DONE RIGHT TRIAL PROGRAM",
      subtitle: "GET INDUSTRIAL-STRENGTH PERFORMANCE, PROVEN IN YOUR FACILITY.",
      body: "The WD-40 Specialist product line is built to handle the toughest maintenance challenges across industries. Now, with our Job Done Right Trial Program, you can put our solutions to the test—right on your floor, with your team, and your toughest jobs.",
      steps: [
        {
          number: "1",
          title: "ON-SITE ASSESSMENT",
          description: "Our experts visit your facility to understand your systems, challenges, and performance goals. From conveyor lines to electrical panels, we evaluate where you need support most."
        },
        {
          number: "2",
          title: "TAILORED RECOMMENDATIONS BY PRODUCT CATEGORY",
          description: "We match WD-40 Specialist solutions to your specific needs:",
          bulletPoints: [
            {
              title: "Cleaners & Degreasers",
              description: "Remove grease, grime, and contaminants fast"
            },
            {
              title: "Lubricants & Penetrants",
              description: "Free stuck parts and reduce friction"
            },
            {
              title: "Rust Solutions",
              description: "Stop rust and protect metal surfaces"
            }
          ]
        },
        {
          number: "3",
          title: "TRIAL IMPLEMENTATION",
          description: "We'll run a live trial in your environment to demonstrate product performance where it matters most—on the job. You'll receive a detailed Findings Report with key metrics, ROI, and measurable improvements."
        },
        {
          number: "4",
          title: "LONG-TERM OPTIMIZATION",
          description: "The trial is just the beginning. Our team supports your ongoing success with training, product guidance, and evolving solutions as your facility grows."
        }
      ]
    },
    {
      component: "site-assessment-form"
    },
    {
      component: "cardDeck",
      variant: 'faqs',
      id: "food-beverage-faqs",
      title: "FREQUENTLY ASKED QUESTIONS",
      cards: [
        {
          id: "faq-1",
          title: "What’s the difference between WD-40 Multi-Use Product and WD-40 Specialist?",
          body: "The iconic WD-40 Multi-Use Product in the blue and yellow can with the little red top made its first appearance on store shelves in San Diego in the 1950’s. Our brand has since grown to include the WD-40 Specialist line of over 20 high-performance maintenance products, including powerful penetrants, lubricants, cleaners, degreasers, and rust management solutions formulated for industrial sector end-users to get their Jobs Done Right® in the most demanding situations. We’re excited to introduce our new Food-Grade and Food-Processing Facility products into the WD-40 Specialist lineup."
        },
        {
          id: "faq-2",
          title: "Are WD-40 Specialist Food-Grade and Food-Processing Facility products NSF registered?",
          body: "Yes. The following products are NSF registered: WD-40 Specialist Food-Grade Lubricant & Penetrant (NSF H1)WD-40 Specialist Food-Processing Facility Electric Contact Cleaner (NSF H2) WD-40 Specialist Food-Processing Facility Degreaser & Cleaner EZ-­Pods (NSF A 1, A2, A4, A8)"
        },
        {
          id: "faq-3",
          title: "What types of surfaces are WD-40 Specialist Food-Processing Facility Cleaners safe to use on?",
          body: "<a href='/products/wd-40-specialist-food-processing-facility-electric-contact-cleaner/' target='_blank'>WD-40 Specialist Food-Processing Facility Electric Contact Cleaner</a> is safe on most plastics, rubbers, and metals, drying fast without leaving residue behind. <a href='/products/wd-40-specialist-food-processing-facility-degreaser-cleaner-ez-pods-2pk/' target='_blank'>WD-40 Specialist Food-Processing Facility Degreaser & Cleaner EZ-Pods</a> are safe on multiple surfaces as well, including most metals, plastics, rubbers, neoprene, stainless steel, and even carbon fiber."
        }
      ],
      ctaText: "ASK A TECHNICAL SPECIALIST",
      ctaUrl: "/industrial/technicalspecialist/"
    }
  ],

};
